import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import SignatureCanvas from "react-signature-canvas";
import dataURLtoBlob from "blueimp-canvas-to-blob";
import $ from "jquery";
import * as R from "ramda";

import idcard from "../../../../../../assets/images/svg/035-id-card.svg";
import solidaire from "../../../../../../assets/images/svg/004-B-solidaire.svg";
import retirement from "../../../../../../assets/images/svg/036-retirement.svg";
import { FileTypes } from "../../../../../../constants/utils/fileTypes";

import { useHistory } from "react-router-dom";

import { uploadDocument, downloadDocumentAsBase64, deleteDocument, updateRelocationDeclaration, getDocuments } from "../../../../../../actions/events-api";

import * as loadings from "../../../../../../constants/loadings/relocationDeclaration";
import { toast } from "react-toastify";

const toastConf = { position: toast.POSITION.TOP_RIGHT, autoClose: 3000 };

export const Step4 = ({ userId, signatureFile, relocationDeclaration, isLoading, setOnboardingStep, getDeclaration, fetchLifeEvents, generateLettersForUserId }) => {
	const dispatch = useDispatch();
	const signatureRef = useRef(null);
	const signatureCanvasRef = useRef({});

	const [width, setWidth] = useState(0);
	const [height, setHeight] = useState(0);
	const [widthWindow, setWidthWindow] = useState(window.innerWidth);
	const [file, setFile] = useState(undefined);
	const [hasBeenDrawn, setHasBeenDrawn] = useState(false);
	const [wasValidated, setWasValidated] = useState(false);

	const [canvasViewMode, setCanvasViewMode] = useState(undefined);
	const [textSignature, setTextSignature] = useState(undefined);

	const fileSelector = document.createElement("input");
	fileSelector.setAttribute("type", "file");
	fileSelector.setAttribute("accept", "image/*");
	fileSelector.onchange = function (event) {
		const nameSplited = event.target.files[0].name.split(".");
		const extension = nameSplited[nameSplited.length - 1].toLowerCase();
		const fileExtesions = ["jpg", "png", "jpeg", "pdf", "svg", "gif"];
		if (!fileExtesions.includes(extension)) {
			toast.error("Seuls les fichiers image sont autorisés !", toastConf);
			return;
		}
		dispatch(uploadDocument(userId, FileTypes.Signature, event.target.files[0]));
	};

	function resize() {
		if (widthWindow > 0 ) {
			if (!R.isNil(signatureRef) && !R.isNil(signatureRef.current) && (width !== signatureRef.current.clientWidth || height !== signatureRef.current.clientHeight)) {
				setWidth(signatureRef.current.clientWidth);
				setHeight(signatureRef.current.clientHeight);
			}
		}
	}

	function saveSignature() {
		const canvas = signatureCanvasRef.current.getCanvas();
		const blob = dataURLtoBlob(canvas.toDataURL("image/png", 1.0));
		blob.name = "signature.png";
		dispatch(uploadDocument(userId, FileTypes.Signature, blob)).then(() => {
			setHasBeenDrawn(false);
		});
	}

	function sendToCanvas() {
		const canvas = signatureCanvasRef.current.getCanvas();
		const ctx = canvas.getContext('2d');
		//const img = new Image();
		//ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
		ctx.font = '400 64px Calligraffitti';
		ctx.textAlign = 'left';
		ctx.fillStyle = '#000000';
		ctx.fillText(textSignature, 5, canvas.height / 2);
	}

	useEffect(() => {
		if (!R.isNil(signatureFile)) {
			downloadDocumentAsBase64(userId, signatureFile.fileName).then((downloadedFile) => {
				setFile(downloadedFile);
			});
		}
	}, [signatureFile]);

	useEffect(() => {
		resize();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		const handleResize = () => setWidthWindow(window.innerWidth);
		window.addEventListener("resize", handleResize);
		resize();
		// return () => {
		// 	window.removeEventListener("resize", handleResize);
		// };
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [window.innerWidth]);
	return (
		<article className="view-calc pt-3 mb-auto">
			<hr className="d-none" />
			<div className="auto-view scroll-auto pb-4 pb-lg-0">
				<div className="container-fluid">
					<h1 className="text-primary font-weight-bolder mt-2 mb-3">Signature</h1>
					<p className="h4 o-50 mb-md-auto ls-n1 mt-n1">A ce stade, nous avons l'intégralité des informations requises pour créer les démarches administratives.</p>
					<p className="h4 font-weight-bold mt-auto pr-md-4 mb-gutter">Il ne manque plus que votre signature. Vous avez trois options: écrire, dessiner ou télécharger votre signature.</p>

					<form className="block">
						<div className="flex-md-row gx-1 align-items-center mb-2">
							{/* <p className="h4 font-weight-bold mt-auto mb-md-auto col pr-md-4">La seule chose que nous demandons est votre signature</p> */}
							<div className="col-auto">
								<button
									type="button"
									className={"btn p-border rounded-sm btn-alert-aux text-aux border-none ml-auto mr-1" + (canvasViewMode === "Type" || R.isNil(canvasViewMode) ? " active" : "")}
									onClick={(e) => {
										e.preventDefault();
										setCanvasViewMode("Type");
									}}>
									<span className="btn-text px-3">
										Écrivez <span className="d-none d-lg-unset">votre signature</span>
									</span>
									<div className="btn btn-item btn-icon">
										<i className="eva eva-text-outline align-middle fs-lead p-2"></i>
										<i className="eva eva-plus-circle position-absolute fs-root mt-3 ml-3"></i>
									</div>
								</button>

								<button
									type="button"
									className={"btn p-border rounded-sm btn-alert-secondary text-secondary border-none ml-auto mr-1" + (canvasViewMode === "Draw" ? " active" : "")}
									onClick={(e) => {
										e.preventDefault();
										setCanvasViewMode("Draw");
									}}>
									<span className="btn-text px-3">
										Dessinez <span className="d-none d-lg-unset">votre signature</span>
									</span>
									<div className="btn btn-item btn-icon">
										<i className="eva eva-edit-outline align-middle fs-lead p-2"></i>
										<i className="eva eva-plus-circle position-absolute fs-root mt-3 ml-3"></i>
									</div>
								</button>

								<button
									type="button"
									className={"btn p-border rounded-sm btn-alert-info text-info border-none ml-auto mr-1" + (canvasViewMode === "Upload" ? " active" : "")}
									onClick={(e) => {
										e.preventDefault();
										setCanvasViewMode("Upload");
										fileSelector.click();
									}}>
									<span className="btn-text px-3">
										Charger <span className="d-none d-lg-unset">une signature</span>
									</span>
									<div className="btn btn-item btn-icon">
										<i className="eva eva-camera-outline align-middle fs-lead p-2"></i>
										<i className="eva eva-plus-circle position-absolute fs-root mt-3 ml-3"></i>
									</div>
								</button>
								{/* { canvasViewMode === "Draw" ?
											<button type="button" className="btn p-border rounded-sm btn-alert-secondary text-secondary border-none ml-auto mr-0" disabled={!R.isNil(file) ? true: false} onClick={(e) => {e.preventDefault(); setCanvasViewMode("Type")}}>
												<span className="btn-text px-3">Écrivez <span className="d-none d-lg-unset">votre signature</span></span>
												<div className="btn btn-item btn-icon"><i className="eva eva-text-outline align-middle fs-lead p-2"></i><i className="eva eva-plus-circle position-absolute fs-root mt-3 ml-3"></i></div>
											</button>
										:
											<button type="button" className="btn p-border rounded-sm btn-alert-secondary text-secondary border-none ml-auto mr-0" disabled={!R.isNil(file) ? true: false} onClick={(e) => {e.preventDefault(); setCanvasViewMode("Draw")}}>
												<span className="btn-text px-3">Dessinez <span className="d-none d-lg-unset">votre signature</span></span>
												<div className="btn btn-item btn-icon"><i className="eva eva-edit-outline align-middle fs-lead p-2"></i><i className="eva eva-plus-circle position-absolute fs-root mt-3 ml-3"></i></div>
											</button>
									} */}
								{/* <Link to="/anticipa/personal" className="btn p-border rounded-sm btn-white-info text-info ml-auto mr-0"><span className="btn-text px-3">Charger une <span className="d-none d-md-unset">signature</span></span><div className="btn btn-item btn-icon"><i className="eva eva-camera-outline align-middle fs-lead p-2"></i><i className="eva eva-plus-circle position-absolute fs-root mt-3 ml-3"></i></div></Link> */}
							</div>
						</div>
						<div className="form-group bg-light rounded p-4">
							<div className="block rounded" ref={signatureRef}>
								{R.isNil(file) ? (
									<div className="block">
										<p style={{ display: canvasViewMode === "Upload" ? "block" : "none" }} className="text-gray small mih-preview mt-0">
											{" "}
											Chargez votre signature ici... <br />
											<span className="o-60">Images haute résolution (png, jpg, gif)</span>
										</p>
										<SignatureCanvas
											style={{ display: canvasViewMode === "Draw" ? "block" : "none" }}
											penColor="black"
											ref={signatureCanvasRef}
											canvasProps={{ width: width, height: height, className: "sigCanvas" + (canvasViewMode !== "Draw" ? " d-none" : "") }}
											onEnd={() => {
												setHasBeenDrawn(true);
											}}
										/>
										<textarea
											style={{ display: canvasViewMode === "Type" || R.isNil(canvasViewMode) ? "block" : "none" }}
											className="form-control signature-control h-5"
											rows="3"
											placeholder="signature"
											onChange={(e) => {
												if (e.target.value !== "") {
													setHasBeenDrawn(true);
													setTextSignature(e.target.value);
												} else {
													setHasBeenDrawn(false);
												}
											}}></textarea>
									</div>
								) : (
									<img className="img-fluid" src={`${file.base64Content}`} alt="signature" />
								)}
							</div>
							<div className="block">
								{!R.isNil(file) ? (
									<button
										type="button"
										className="btn btn-alert-danger border-none mr-2"
										onClick={() => {
											dispatch(deleteDocument(userId, signatureFile.fileName)).then(() => {
												setFile(undefined);
												setHasBeenDrawn(false);
											});
										}}>
										Supprimer
									</button>
								) : (
									""
								)}

								{hasBeenDrawn ? (
									<button
										type="button"
										className="btn btn-alert-info border-none mr-2"
										onClick={(e) => {
											if (canvasViewMode !== "Draw") sendToCanvas();
											saveSignature();
										}}>
										Sauvegarder
									</button>
								) : (
									""
								)}
							</div>
							{wasValidated && R.isNil(file) ? (
								<div>
									<i className="eva eva-alert-triangle-outline text-warning mr-1 fs-sm lh-root align-middle"></i>
									<span className="align-middle text-dark o-70">Veuillez ajouter votre signature</span>
								</div>
							) : (
								""
							)}

							{/* <div className="form-check">
									<input className="form-check-input" type="checkbox" value="" id="flexCheckChecked" />
									<label className="form-check-label font-weight-bold text-gray" htmlFor="flexCheckChecked">
										Enregistrer la signature
									</label>
								</div> */}
						</div>
					</form>
				</div>
			</div>

			<div className="container-fluid">
				<footer className="d-block mt-auto mb-sm text-right w-100">
					<button
						className="btn btn-faded px-md-gutter mr-3"
						onClick={() => {
							setOnboardingStep(3);
						}}>
						Retour
					</button>
					{isLoading.includes(loadings.UPDATING_RELOCATION_DECLARATION) ? (
						<button type="button" className="btn btn-info loading-btn px-md-gutter px-4 show">
							Démarrer le processus<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
						</button>
					) : (
						<button
							type="button"
							disabled={R.isNil(file)}
							className={"btn btn-info loading-btn px-md-gutter px-4"}
							onClick={async (event) => {
								event.preventDefault();
								dispatch(updateRelocationDeclaration(userId, { ...relocationDeclaration, onBoardingStep: 5 })).then(() => {
									getDeclaration();
									setOnboardingStep(5);
									generateLettersForUserId();
									dispatch(fetchLifeEvents(userId));
									$("#declareRelocation").modal("hide");
								});
							}}>
							Démarrer le processus<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
						</button>
					)}
				</footer>
			</div>
		</article>
	);
};
